import {
    MonitoredEvent,
    NOTE_EVENT_CLAZZ_VALUE,
    NoteEvent,
    OPS_INSTRUCTION_CLAZZ_VALUE,
    OpsInstruction,
    WEATHER_EVENT_CLAZZ_VALUE,
    WeatherEvent,
} from 'app/model/SOL49';
import TimeUtils from 'app/common/util/TimeUtils';
import TimePeriodUtils from 'app/common/util/TimePeriodUtils';
import AppContext from 'app/common/context/AppContext';
import memoizeOne from 'memoize-one';

export enum MonitoredEventType {
    NOTE = 'NOTE',
    OPS_INSTRUCTION = 'OPS_INSTRUCTION',
    WEATHER_EVENT = 'WEATHER_EVENT',
}

export class MonitoredEventUtils {
    // Last updated event first
    static cmpMonitoredEvent = (a: MonitoredEvent, b: MonitoredEvent) => TimeUtils.compare(b.lastUpdate, a.lastUpdate);

    static isWeatherEvent(event: MonitoredEvent): event is WeatherEvent {
        return event.clazz === WEATHER_EVENT_CLAZZ_VALUE;
    }

    static isNoteEvent(event: MonitoredEvent): event is NoteEvent {
        return event.clazz === NOTE_EVENT_CLAZZ_VALUE;
    }

    static isOpsInstruction(event: MonitoredEvent): event is OpsInstruction {
        return event.clazz === OPS_INSTRUCTION_CLAZZ_VALUE;
    }

    static getType(event: MonitoredEvent) {
        switch (event.clazz) {
            case NOTE_EVENT_CLAZZ_VALUE:
                return MonitoredEventType.NOTE;
            case WEATHER_EVENT_CLAZZ_VALUE:
                return MonitoredEventType.WEATHER_EVENT;
            case OPS_INSTRUCTION_CLAZZ_VALUE:
                return MonitoredEventType.OPS_INSTRUCTION;
        }
    }

    static getFiltersOptions = (events: WeatherEvent[]) => Array.from(new Set(events?.map(event => event.type)));

    static isActive = (event: MonitoredEvent) =>
        TimePeriodUtils.intersects(event.validity, AppContext.getTodayPeriod());

    static activeEvents = memoizeOne((events: MonitoredEvent[]) => events?.filter(MonitoredEventUtils.isActive));
}
